/**
 * Reducer para redes sociais do site ODC.
 * @module reducers/socialNetworks
 */

import { GET_SOCIAL_NETWORKS } from '../constants/ActionTypes';

export interface SocialNetworkItem {
  '@id': string;
  social_network: string;
  social_network_url: string;
}

export interface SocialNetworksState {
  error: unknown;
  loaded: boolean;
  loading: boolean;
  data: { items: SocialNetworkItem[] };
}

const initialState: SocialNetworksState = {
  error: null,
  loaded: false,
  loading: false,
  data: { items: [] },
};

export default function socialNetworks(
  state: SocialNetworksState = initialState,
  action: { type: string; result?: any },
): SocialNetworksState {
  switch (action.type) {
    case `${GET_SOCIAL_NETWORKS}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
        data: { items: [] },
      };
    case `${GET_SOCIAL_NETWORKS}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        data: action.result.social_networks ?? { items: [] },
      };
    case `${GET_SOCIAL_NETWORKS}_FAIL`:
      return {
        ...state,
        error: action.result,
        loaded: false,
        loading: false,
        data: { items: [] },
      };
    default:
      return state;
  }
}
